import React from "react";
import {
    Avatar,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton
} from "@mui/material";
import {LocalLanguage} from "../../data/LocalLanguage";
import { makeStyles } from 'tss-react/mui';
import i18n from "../../i18n/i18n";

interface ChangeLanguageDialogProps{
    languages: LocalLanguage[],
    isOpen: boolean,
    onChange: (newLanguage: LocalLanguage) => void
    onCancel: () => void
}

const useStyles = makeStyles()({
    iconButton: {
        height: "20%",
        width: "20%",
        boxShadow: "5px",
        margin: "20px",
    },
    flag: {
        height: "100%",
        width: "100%",
        border: "solid 0.75px rgb(180, 180, 180)"
    },
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    }
});

const ChangeLanguageDialog = (props: ChangeLanguageDialogProps) => {
    const { languages, isOpen, onChange, onCancel } = props
    const { classes } = useStyles()

    return <Dialog
        open={isOpen}
        fullWidth
        maxWidth={"xs"}
        aria-labelledby="language-dialog-title"
        aria-describedby="language-dialog-description"
    >
        <DialogTitle id={"language-dialog-title"}>
            {i18n.t('applicationRootPage:changeLanguageDialog.title')}
        </DialogTitle>
        <DialogContent className={classes.container} id={"language-dialog-description"}>
            {languages.map((language) => (
                <IconButton
                    key={`language_${language.symbol}`}
                    onClick={() => { onChange(language) }}
                    className={classes.iconButton}
                    data-cy={`flagIconButton_${language.symbol}`}
                    size="large"
                >
                    <Avatar className={classes.flag}>
                        {/* Pass SVG icon as component to prevent visible loading */}
                        <language.image/>
                    </Avatar>
                </IconButton>
            ))}
        </DialogContent>
        <DialogActions>
            <Button onClick={onCancel}>
                {i18n.t('applicationRootPage:changeLanguageDialog.cancel')}
            </Button>
        </DialogActions>
    </Dialog>
};

export default ChangeLanguageDialog;